/**
 * Safe localStorage helpers for authentication data.
 * Never throws on corrupt JSON — clears bad auth keys and returns a fallback.
 */

const AUTH_KEYS = ["LoginTokenData", "AstroLoginId", "UserLoginId"];

export function getStoredAuthData() {
  if (typeof window === "undefined") return {};

  try {
    const value = localStorage.getItem("LoginTokenData");
    if (!value) return {};

    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === "object") return parsed;

    localStorage.removeItem("LoginTokenData");
    return {};
  } catch (error) {
    console.error("Invalid LoginTokenData:", error);
    localStorage.removeItem("LoginTokenData");
    return {};
  }
}

export function clearAuthStorage() {
  if (typeof window === "undefined") return;

  AUTH_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Failed to remove ${key}:`, error);
    }
  });
}
